import React from "react";
import { Controller } from "react-hook-form";
import {
  Input,
  InputNumber,
  DatePicker,
  TimePicker,
  Switch,
  Checkbox,
  message,
  Upload,
} from "antd";
import dayjs from "dayjs";

const DynamicInput = ({ name, control, type, placeholder, setValue }) => {
  const beforeUpload = (file) => {
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    const maxSize = 300 * 1024;
    if (!allowedTypes.includes(file.type)) {
      message.error("You can only upload JPG, PNG, or PDF files!");
      return Upload.LIST_IGNORE;
    }

    if (file.size > maxSize) {
      message.error("File size must be 1MB or smaller!");
      return Upload.LIST_IGNORE;
    }

    return true;
  };
  const handleFileSelect = (filename, file) => {
    if (beforeUpload(file) && file.size <= 1 * 1024 * 1024) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const fileData = {
          name: file.name,
          type: file.type,
          size: file.size,
          base64: reader.result,
        };
        setValue(filename, fileData);
        message.success("File added successfully!");
      };
    }
    return false;
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        console.log("field", type);
        switch (type) {
          case "text":
            return (
              <Input {...field} placeholder={placeholder || "Enter text"} />
            );
          case "number":
            return (
              <InputNumber
                {...field}
                style={{ width: "100%" }}
                placeholder={placeholder || "Enter number"}
              />
            );
          case "bytea":
            return (
              <Upload
                {...field}
                beforeUpload={(file) => {
                  if (beforeUpload(file)) {
                    handleFileSelect(field?.name, file);
                  }
                  return false;
                }}
                onPreview={onPreview}
                fileList={[
                  {
                    uid: "-1",
                    name: field?.value?.name || "",
                    status: "done",
                    url: field?.value?.base64 || "",
                  },
                ]}
              >
                <div
                  style={{
                    border: "1px dashed #ccc",
                    padding: "10px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  Click or Drag File Here (JPG, PNG, PDF)
                </div>
              </Upload>
            );
          case "smallint":
            return <Checkbox checked={field.value} onChange={field.onChange} />;
          case "date":
            return (
              <DatePicker
                {...field}
                value={field.value ? dayjs(field.value) : null}
                onChange={(date) =>
                  field.onChange(date ? dayjs(date).format("YYYY-MM-DD") : null)
                }
                placeholder={placeholder || "Select date"}
              />
            );

          case "timestamp without time zone":
            return (
              <DatePicker
                {...field}
                value={field.value ? dayjs(field.value) : null}
                onChange={(date) =>
                  field.onChange(date ? date.toISOString() : null)
                }
                placeholder={placeholder || "Select date & time"}
                showTime
              />
            );
          case "time without time zone":
            return (
              <TimePicker
                {...field}
                value={field.value ? dayjs(field.value, "HH:mm:ss") : null}
                onChange={(time) =>
                  field.onChange(time ? time.format("HH:mm:ss") : null)
                }
                placeholder={placeholder || "Select time"}
              />
            );
          default:
            return (
              <Input {...field} placeholder={placeholder || "Enter value"} />
            );
        }
      }}
    />
  );
};

export default DynamicInput;
